import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useFaqHook from "../hooks/useFaqHook";

const Faqs = () => {
  const { data, loading, error } = useFaqHook();

  return (
    <Card>
      <CardHeader
        title="FAQ's"
        style={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div>Error loading FAQs</div>
        ) : (
          data.map((faq) => (
            <Accordion key={faq.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${faq.id}-content`}
                id={`panel${faq.id}-header`}
              >
                <Typography>{faq.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{faq.content}</Typography>
              </AccordionDetails>
            </Accordion>
          ))
        )}
      </CardContent>
    </Card>
  );
};

export default Faqs;
